import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'

import { useCallback } from 'react'
import { ButtonCorners, ButtonFluid, ButtonFonts } from 'atoms/Button'
import { PlayerPaymentPrimaryButton } from 'atoms/Button/Templates'
import { TextBox } from 'atoms/TextBox'
import { Colors, TextAligning, TextBoxTypes } from 'atoms/TextBox/TextBox.h'
import { FIXED_INDENTS } from 'vars/index'
import {
  PlayerGoLivePopupButtonSC,
  PlayerGoLivePopupSC,
  PlayerGoLivePopupSmallSC,
} from './PlayerGoLivePopup.styled'

export interface IPlayerGoLivePopupProps extends Pick<IButtonProps, 'onClick'> {
  smallPlayer?: boolean
  title: string
  isFullscreen?: boolean
  buttonTitle: string
}

export const PlayerGoLivePopup = ({
  smallPlayer = false,
  title,
  isFullscreen = false,
  buttonTitle,
  onClick,
}: IPlayerGoLivePopupProps): JSX.Element => {
  const isSmallPlayer = smallPlayer && !isFullscreen

  const config = isSmallPlayer
    ? {
        titleFont: TextBoxTypes.FontLgBold,
        childrenGap: FIXED_INDENTS.INDENT_40,
      }
    : {
        titleFont: TextBoxTypes.FontXlBold,
        childrenGap: FIXED_INDENTS.INDENT_60,
      }

  const { titleFont, childrenGap } = config

  const WrapperSC = isSmallPlayer
    ? PlayerGoLivePopupSmallSC
    : PlayerGoLivePopupSC

  const handleClick = useCallback(
    (e: React.MouseEvent<Element, MouseEvent>) => {
      e.stopPropagation()
      e.preventDefault()
      onClick?.(e)
    },
    [onClick]
  )

  return (
    <WrapperSC gap={childrenGap}>
      <TextBox
        title={title}
        color={Colors.TEXT_ICON_PRIMARY}
        font={titleFont}
        maxLines={2}
        alignment={TextAligning.Center}
      />

      <PlayerGoLivePopupButtonSC isSmallPlayer={isSmallPlayer}>
        <PlayerPaymentPrimaryButton
          fluid={ButtonFluid.Both}
          corners={ButtonCorners.CORNERS_10}
          font={ButtonFonts.FontSmBold}
          title={buttonTitle}
          onClick={handleClick}
        />
      </PlayerGoLivePopupButtonSC>
    </WrapperSC>
  )
}
